import ShopType from "@/enum/ShopType";
import { useModalStore } from "@/hooks/Modal/hooks";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { getSubscribeUrlByShopType } from "@/services/subscribeServices";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import RenewalModal from "./RenewalModal";

interface RenewalItemProps {
    shopType?: string;
}

function getRealShopInfo(shopType: string) {
    let name = ShopTypeNameMap[shopType];

    if (shopType === "TAOTE") {
        shopType = ShopType.TAOBAO;
        name = "淘特";
    } else if (shopType === "TMALL") {
        shopType = ShopType.TAOBAO;
        name = "天猫";
    } else if (shopType === "JINGLING") {
        shopType = ShopType.WEBUY;
        name = "鲸灵";
    }

    return {
        name,
        shopType: shopType as ShopType,
    };
}

/**
 * 不同店铺对应的续费按钮
 */
const RenewalItem: React.FC<RenewalItemProps> = observer(function (props) {
    const { shopType } = props;

    const modalStore = useModalStore();

    const shopInfo = useMemo(() => getRealShopInfo(shopType), [shopType]);
    const url = useMemo(() => getSubscribeUrlByShopType(shopInfo.shopType), [shopInfo]);

    if (url) {
        return (
            <a target="_blank" href={url}>
                {shopInfo.name}
            </a>
        );
    }

    return (
        <a
            role="button"
            onClick={() => {
                modalStore.openModal(RenewalModal, {
                    shopType: shopInfo.shopType,
                });
            }}
        >
            {shopInfo.name}
        </a>
    );
});

export default RenewalItem;
